import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import "../Components/CSS/Global.css";

import client1 from "../Components/img/Our Clients/1.png";
import client2 from "../Components/img/Our Clients/2.png";
import client3 from "../Components/img/Our Clients/3.png";
import client4 from "../Components/img/Our Clients/4.png";
import client5 from "../Components/img/Our Clients/5.png";
import client6 from "../Components/img/Our Clients/6.png";
import client7 from "../Components/img/Our Clients/7.png";
import client8 from "../Components/img/Our Clients/8.png";
import client9 from "../Components/img/Our Clients/9.png";
import client10 from "../Components/img/Our Clients/10.png";
import client11 from "../Components/img/Our Clients/11.png";
import client12 from "../Components/img/Our Clients/12.png";
import client13 from "../Components/img/Our Clients/13.png";
import client14 from "../Components/img/Our Clients/14.png";
import client15 from "../Components/img/Our Clients/15.png";
import client16 from "../Components/img/Our Clients/16.png";
import client17 from "../Components/img/Our Clients/17.png";
import client18 from "../Components/img/Our Clients/18.png";
import client19 from "../Components/img/Our Clients/19.png";
import client20 from "../Components/img/Our Clients/20.png";
import client21 from "../Components/img/Our Clients/21.png";
import client22 from "../Components/img/Our Clients/22.png";
import client23 from "../Components/img/Our Clients/23.png";
import client24 from "../Components/img/Our Clients/24.png";
import client25 from "../Components/img/Our Clients/25.png";
import client26 from "../Components/img/Our Clients/26.png";
import client27 from "../Components/img/Our Clients/27.png";
import client28 from "../Components/img/Our Clients/28.png";
import client29 from "../Components/img/Our Clients/29.png";
import client30 from "../Components/img/Our Clients/30.png";
import client31 from "../Components/img/Our Clients/31.png";
import client32 from "../Components/img/Our Clients/32.png";
import client33 from "../Components/img/Our Clients/33.png";
import client34 from "../Components/img/Our Clients/34.png";
import client35 from "../Components/img/Our Clients/35.png";
import client36 from "../Components/img/Our Clients/36.png";
import client37 from "../Components/img/Our Clients/37.png";
import client38 from "../Components/img/Our Clients/38.png";
import client39 from "../Components/img/Our Clients/41.png";
import client40 from "../Components/img/Our Clients/39.png";
import client41 from "../Components/img/Our Clients/40.png";


const clientImages = [
  client1, client2, client3, client4, client5, client6, client7, client8, client9, client10,
  client11, client12, client13, client14, client15, client16, client17, client18, client19, client20,
  client21, client22, client23, client24, client25, client26, client27, client28, client29, client30,
  client31, client32, client33, client34, client35, client41, client36, client37, client38, client39,
  client40,
];

const ClientCarousel = () => {
  return (
    <>
      <div className="clients">
        <h1 className="Client-title">Our Clients</h1>
        <OwlCarousel
          className='owl-theme'
          loop
          margin={10}
          nav
          autoplay
          autoplayTimeout={3000}
          dots={false}
          mouseDrag={true}
          touchDrag={true}
          navText={[
            "<i class='fa fa-chevron-left'></i>",
            "<i class='fa fa-chevron-right'></i>"
          ]}
          responsive={{
            0: {
              items: 2,
              nav: false,
            },
            600: { items: 3 },
            1000: { items: 4 }
          }}
        >
          {clientImages.map((clientImage, index) => (
            <div key={index} className="item">
              <img src={clientImage} alt={`Client ${index + 1}`} className="carousel-image" />
            </div>
          ))}
        </OwlCarousel>
      </div>
    </>
  );
};

export default ClientCarousel;
